import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface ICustomFilter {
    airportCode: string;
}

interface FlightSummaryState {
    hasfilterApplied: boolean;
    search: string;
    customFilter: ICustomFilter;
}

const initialState: FlightSummaryState = {
    hasfilterApplied: false,
    search: '',
    customFilter: {
        airportCode: 'ALL',
    },
};

export const airlineManagementSlice = createSlice({
    name: 'airlineManagement',
    initialState,
    reducers: {
        setSearch: (state, action: PayloadAction<string | null>) => {
            state.search = action.payload;
        },

        setAirportCode: (state, action: PayloadAction<string>) => {
            state.customFilter.airportCode = action.payload;
        },

        applyFilter: (state) => {
            state.hasfilterApplied = true;
        },

        clearFilter: (state) => {
            state.search = '';
            state.hasfilterApplied = false;
            state.customFilter.airportCode = 'ALL';
        },
    },
});

export const { setSearch, setAirportCode, applyFilter, clearFilter } = airlineManagementSlice.actions;

export default airlineManagementSlice.reducer;
